import { iterateBreakpoints } from 'app/functions/grid';

/**
 * This function will generate a list of breakpoint widths, in pixels.
 * The 0px breakpoint will not be included.
 */
export const getBreakpointConfiguration = () =>
    iterateBreakpoints().slice(1).map(n => `${n}px`);
